[
    {
        "field": "prcocessing_status_lkp",
        "header": "Processing Status"
    },
    {
        "field": "business_status_lkp",
        "header": "Business Status"
    },
    {
        "field": "is_active",
        "header": "Is Active"
    },
    {
        "field": "servicecode_rate",
        "header": "Service Rate"
    }
]